"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.panelEditDisplay = exports.panelEditDisplayUseIndex = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _NestedComponent = _interopRequireDefault(require("../nested/NestedComponent.form"));

var _PanelEdit = _interopRequireDefault(require("./editForm/Panel.edit.display"));

var _PanelEdit2 = _interopRequireDefault(require("./editForm/Panel.edit.conditional"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var panelEditDisplayUseIndex = {
  weight: 1,
  input: true,
  type: 'checkbox',
  label: 'Use Component Index',
  key: 'useIndex'
};
exports.panelEditDisplayUseIndex = panelEditDisplayUseIndex;
var panelEditDisplay = [{
  key: 'label',
  hidden: true,
  calculateValue: 'value = data.title'
}, // Скрыты labelPosition и placeholder
{
  key: 'labelPosition',
  hidden: true
}, {
  key: 'placeholder',
  hidden: true
}, {
  weight: 0,
  type: 'textfield',
  input: true,
  placeholder: 'Panel Title',
  label: 'Title',
  key: 'title',
  tooltip: 'The title text that appears in the header of this panel.'
}, // Добавлен Component index
{
  weight: 2,
  type: 'textfield',
  input: true,
  placeholder: 'Component index',
  label: 'Component index',
  key: 'componentIndex',
  tooltip: 'Отображается слева от title. Вводить вместе с разделителями, если нужны. \n' + 'Примеры: "А.1.", "b.2", "С/3", "—". \n' + 'Если ничего не ввести, элемента-маркера не будет.',
  conditional: {
    json: {
      var: 'data.useIndex'
    }
  }
}, {
  weight: 20,
  type: 'textarea',
  input: true,
  key: 'tooltip',
  label: 'Tooltip',
  placeholder: 'To add a tooltip to this field, enter text here.',
  tooltip: 'Adds a tooltip to the side of this field.'
}, {
  weight: 30,
  type: 'select',
  input: true,
  label: 'Theme',
  key: 'theme',
  dataSrc: 'values',
  data: {
    values: [{
      label: 'Default',
      value: 'default'
    }, {
      label: 'Primary',
      value: 'primary'
    }, {
      label: 'Info',
      value: 'info'
    }, {
      label: 'Success',
      value: 'success'
    }, {
      label: 'Danger',
      value: 'danger'
    }, {
      label: 'Warning',
      value: 'warning'
    }]
  }
}, {
  weight: 40,
  type: 'fieldset',
  input: false,
  components: [{
    type: 'select',
    input: true,
    label: 'Breadcrumb Type',
    key: 'breadcrumb',
    dataSrc: 'values',
    data: {
      values: [{
        label: 'Default',
        value: 'default'
      }, {
        label: 'Condensed',
        value: 'condensed'
      }, {
        label: 'Hidden',
        value: 'none'
      }]
    }
  }, {
    input: true,
    type: 'checkbox',
    label: 'Allow click on Breadcrumb',
    key: 'breadcrumbClickable',
    defaultValue: true,
    conditional: {
      json: {
        '!==': [{
          var: 'data.breadcrumb'
        }, 'none']
      }
    }
  }, {
    weight: 50,
    label: 'Panel Navigation Buttons',
    optionsLabelPosition: 'right',
    values: [{
      label: 'Previous',
      value: 'previous'
    }, {
      label: 'Cancel',
      value: 'cancel'
    }, {
      label: 'Next',
      value: 'next'
    }],
    inline: true,
    type: 'selectboxes',
    key: 'buttonSettings',
    input: true,
    inputType: 'checkbox',
    defaultValue: {
      previous: true,
      cancel: true,
      next: true
    }
  }],
  customConditional: 'show = instance.root.editForm.display === "wizard"'
}, {
  weight: 650,
  type: 'checkbox',
  label: 'Collapsible',
  tooltip: 'If checked, this will turn this Panel into a collapsible panel.',
  key: 'collapsible',
  input: true
}, {
  weight: 651,
  type: 'checkbox',
  label: 'Initially Collapsed',
  tooltip: 'Determines the initial collapsed state of this Panel.',
  key: 'collapsed',
  input: true,
  conditional: {
    json: {
      '===': [{
        var: 'data.collapsible'
      }, true]
    }
  }
}, {
  weight: 652,
  type: 'checkbox',
  label: 'Lazy Load Contents',
  tooltip: 'Lazy loads the contents only when the panel is opened.',
  key: 'lazyLoad',
  input: true,
  conditional: {
    json: {
      '===': [{
        var: 'data.collapsed'
      }, true]
    }
  }
}];
exports.panelEditDisplay = panelEditDisplay;

function _default() {
  for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
    extend[_key] = arguments[_key];
  }

  return _NestedComponent.default.apply(void 0, [[{
    key: 'display',
    components: [].concat(_toConsumableArray(_PanelEdit.default), panelEditDisplay, [panelEditDisplayUseIndex])
  }, {
    key: 'conditional',
    components: _PanelEdit2.default
  }]].concat(extend));
}